import { Component, Input } from '@angular/core';
import { ManualPaymentConfiguration } from 'app/shared/models/manual-payment-configuration.model';

@Component({
  selector: 'ez-manual-payment',
  imports: [],
  templateUrl: './manual-payment.component.html',
  styleUrl: './manual-payment.component.scss',
})
export class ManualPaymentComponent {
  @Input({ required: true }) manualPaymentConfiguration: ManualPaymentConfiguration;
  @Input({ required: true }) reasonForPayment: string;

  formatIban(iban: string) {
    return iban.replace(/\w{4}(?=.)/g, '$& ');
  }
}
